import { NgIf, TitleCasePipe } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { MiscSvgComponent } from '@curbnturf/custom-svgs/src/lib/misc-svg/misc-svg.component';
import { Boondock, Site } from '@curbnturf/entities';
import { ContactHostComponent } from '../contact-host/contact-host.component';

@Component({
  selector: 'curbnturf-isolation-display',
  templateUrl: './isolation-display.component.html',
  styleUrls: ['./isolation-display.component.scss'],
  standalone: true,
  imports: [NgIf, MiscSvgComponent, ContactHostComponent, TitleCasePipe],
})
export class IsolationDisplayComponent implements OnChanges {
  @Input() site: Site | Boondock;

  visibilityString: string;

  showIsolation: boolean = false;
  showNoise: boolean = false;

  showRoadConditionDescription: boolean = false;

  get potentialHazards(): boolean {
    if ((this.site as Site)?.listing?.potentialHazards) {
      return (this.site as Site).listing?.potentialHazards || false;
    }

    return false;
  }

  get potentialHazardDescription(): string {
    if ((this.site as Site)?.listing?.potentialHazardDescription) {
      return (this.site as Site).listing?.potentialHazardDescription || '';
    }

    return '';
  }

  ngOnChanges() {
    this.visibilityString = this.calculateVisibilityString(this.site);
    if (this.site && this.site.noise && this.site.noise.level) {
      this.showNoise = true;
    } else {
      this.showNoise = false;
    }
  }

  displayRoadConditions() {
    const conditionsArray: string[] = [];
    if (this.site) {
      const roadCondition = this.site.roadCondition;
      if (roadCondition.paved) {
        conditionsArray.push('Paved');
      }
      if (roadCondition.smoothGravel) {
        conditionsArray.push('Smooth Gravel');
      }
      if (roadCondition.poorGravel) {
        conditionsArray.push('Poor Gravel');
      }
      if (roadCondition.offRoad) {
        conditionsArray.push('Off Road');
      }
      if (roadCondition.highClearance) {
        conditionsArray.push('High Clearance');
      }
    }

    return conditionsArray.join(', ');
  }

  displayRoadConditionDescriptions() {
    const conditionsArray: string[] = [];
    if (this.site) {
      const roadCondition = this.site.roadCondition;
      if (roadCondition.paved && roadCondition.pavedDescription) {
        conditionsArray.push(`Paved: ${roadCondition.pavedDescription}`);
      }
      if (roadCondition.smoothGravel && roadCondition.smoothGravelDescription) {
        conditionsArray.push(`Smooth Gravel: ${roadCondition.smoothGravelDescription}`);
      }
      if (roadCondition.poorGravel && roadCondition.poorGravelDescription) {
        conditionsArray.push(`Poor Gravel: ${roadCondition.poorGravelDescription}`);
      }
      if (roadCondition.offRoad && roadCondition.offRoadDescription) {
        conditionsArray.push(`Off Road: ${roadCondition.offRoadDescription}`);
      }
      if (roadCondition.highClearance && roadCondition.highClearanceDescription) {
        conditionsArray.push(`High Clearance: ${roadCondition.highClearanceDescription}`);
      }
    }

    return conditionsArray.join(' - ');
  }

  private calculateVisibilityString(site: Site | Boondock): string {
    const privacy = site.privacy;

    if (!privacy || (!privacy.home && !privacy.neighbor && !privacy.others && !privacy.secluded)) {
      this.showIsolation = false;
      return '';
    }

    this.showIsolation = true;

    if (privacy.secluded) {
      return 'Site is secluded';
    }

    const visible = [];
    if (privacy.home) {
      visible.push("host's home");
    }
    if (privacy.neighbor) {
      visible.push('neighbors');
    }
    if (privacy.others) {
      visible.push('other CurbNTurfers');
    }

    if (visible.length > 1) {
      return `The following are visible from the site: ${visible.join(', ')}.`;
    }

    return `From the site you can see ${visible.join(', ')}.`;
  }
}
